import {Component, Input} from '@angular/core';
import {WriteReviewDialogService} from './write-review-dialog.service';
import {G2Product} from '../../../models/g2-review.model';

@Component({
  selector: 'dcp-write-review',
  templateUrl: './write-review.component.html',
  styleUrls: ['./write-review.component.scss'],
})
export class WriteReviewComponent {
  @Input() g2Product: G2Product;
  @Input() btnLabel: string;

  constructor(public writeReviewDialogService: WriteReviewDialogService) {}
}
